<template>
    <div>
        <el-dialog
            title="查看"
            :visible.sync="teamId.state"
            width="60%"
            class="dialog_container"
            @close="examineDialogClose"
            append-to-body
        >
            <div class="dialog_content">
                <div class="team1">
                    <div class="team1-left">
                        <div class="team1-content">
                            <div>团队名称：</div>
                            <div>
                                <el-input
                                    size="medium"
                                    style="width: 300px"
                                    disabled
                                    v-model="formData.name"
                                ></el-input>
                            </div>
                        </div>
                        <div class="team1-content">
                            <div>成立时间：</div>
                            <div>
                                <el-input
                                    size="medium"
                                    style="width: 300px"
                                    disabled
                                    v-model="formData.establishDate"
                                ></el-input>
                            </div>
                        </div>
                        <div class="team1-content">
                            <div>报名时间：</div>
                            <div>
                                <el-input
                                    size="medium"
                                    style="width: 300px"
                                    disabled
                                    v-model="formData.signupStartTime"
                                ></el-input>
                            </div>
                        </div>
                        <div class="team1-content">
                            <div>联系人：</div>
                            <div>
                                <el-input
                                    size="medium"
                                    style="width: 300px"
                                    disabled
                                    v-model="formData.contacts"
                                ></el-input>
                            </div>
                        </div>
                        <div class="team1-content">
                            <div>联系电话：</div>
                            <div>
                                <el-input
                                    size="medium"
                                    style="width: 300px"
                                    disabled
                                    v-model="formData.phone"
                                ></el-input>
                            </div>
                        </div>
                        <div class="team1-content">
                            <div>计划招募人数：</div>
                            <div>
                                <el-input
                                    size="medium"
                                    style="width: 300px"
                                    disabled
                                    v-model="formData.recruitNumber"
                                ></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="team1-right">
                        <div>团队名称：</div>
                        <!-- <img src="../../../timeBank/assets/img/user.png" style="width: 300px;height: 200px;"> -->
                        <img
                            :src="formData.photo"
                            style="width: 300px; height: 200px"
                        />
                    </div>
                </div>
                <div class="team2">
                    <div>团队地址：</div>
                    <div>
                        <el-input
                            size="medium"
                            style="width: 700px"
                            disabled
                            v-model="formData.address"
                        ></el-input>
                    </div>
                </div>

                <div class="map_container1">
                    <div
                        id="container1"
                        style="width: 100%; height: 200px"
                    ></div>
                </div>
                <div class="team2">
                    <div>加入条件：</div>
                    <div>
                        <el-input
                            size="medium"
                            style="width: 700px"
                            disabled
                            v-model="formData.joinConditions"
                        ></el-input>
                    </div>
                </div>
                <div class="team2">
                    <div>招募说明：</div>
                    <div>
                        <el-input
                            size="medium"
                            style="width: 700px"
                            disabled
                            v-model="formData.recruitExplain"
                        ></el-input>
                    </div>
                </div>
                <div class="team2">
                    <div>服务类别：</div>
                    <div style="width: 80%; line-height: 30px">
                        <el-checkbox-group v-model="formData.serviceType">
                            <el-checkbox label="0" disabled
                                >赛会服务</el-checkbox
                            >
                            <el-checkbox label="1" disabled
                                >应急救援</el-checkbox
                            >
                            <el-checkbox label="2" disabled
                                >城市运行</el-checkbox
                            >
                            <el-checkbox label="3" disabled
                                >文化教育</el-checkbox
                            >
                            <el-checkbox label="4" disabled
                                >关爱教育</el-checkbox
                            >
                            <el-checkbox label="5" disabled
                                >社区服务</el-checkbox
                            >
                            <el-checkbox label="6" disabled
                                >医疗卫生</el-checkbox
                            >
                            <el-checkbox label="7" disabled>其他</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
                <div class="team2">
                    <div>发布平台：</div>
                    <div style="width: 80%; line-height: 30px">
                        <el-checkbox-group v-model="formData.publishPlatform">
                            <el-checkbox label="0" disabled>APP</el-checkbox>
                            <!-- <el-checkbox label="1" disabled>公众号</el-checkbox> -->
                        </el-checkbox-group>
                    </div>
                </div>
                <el-table
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    height="200"
                    :header-cell-style="{
                        background: '#e6e6e6',
                        color: '#000',
                    }"
                    border
                >
                    <el-table-column
                        type="index"
                        width="50"
                        prop="id"
                        label="序号"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        prop="number"
                        label="志愿者编号"
                        width="120"
                        align="center"
                        :show-overflow-tooltip="true"
                    ></el-table-column>

                    <el-table-column
                        prop="name"
                        label="用户姓名"
                        width="120"
                        align="center"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        prop="sex"
                        label="性别"
                        align="center"
                        width="120"
                        :show-overflow-tooltip="true"
                    >
                        <template slot-scope="{ row: { sex } }">
                            <span v-if="sex == 0">男</span>
                            <span v-if="sex == 1">女</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="phone"
                        width="120"
                        label="手机"
                        align="center"
                        :show-overflow-tooltip="true"
                    ></el-table-column>

                    <el-table-column
                        prop="address"
                        label="居住地址"
                        align="center"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="age"
                        label="年龄"
                        align="center"
                        :show-overflow-tooltip="true"
                        width="120"
                    >
                    </el-table-column>
                </el-table>
                <div class="pagination_container">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[10, 20, 40, 100]"
                        :page-size="query.pageSize"
                        :current-page.sync="query.pageNo"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                    >
                    </el-pagination>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import request from "@/utils/request.js"
export default {
    props: ["teamId"],
    data() {
        return {
            total: 0,
            tableData: [],
            marker: [],
            map: null,
            query: {
                pageNo: 1,
                pageSize: 10,
            },
            formData: {
                serviceType: [],
                publishPlatform: [],
            },
            examineDialog: false,
            examineData: {
                name: "去去去",
            },
            signUpTableData: [
                {
                    name: "a啊",
                },
                {
                    name: "a啊",
                },
            ],
        }
    },
    async mounted() {
        this.$nextTick(function () {
            setTimeout(() => {
                this.loadMap()
                this.getData()
            }, 30)
        })
    },

    methods: {
        getData() {
            request({
                url: "/sqyl/admin/corporationRecruitment/info/get",
                method: "POST",
                data: {
                    id: this.teamId.id,
                },
            }).then((res) => {
                if (res.code == 200) {
                    this.formData = res.content
                    if (res.content.serviceType) {
                        this.formData.serviceType =
                            res.content.serviceType.split(",")
                    } else {
                        this.formData.serviceType = []
                    }
                    if (res.content.publishPlatform) {
                        this.formData.publishPlatform =
                            res.content.publishPlatform.split(",")
                    } else {
                        this.formData.publishPlatform = []
                    }
                    this.total = this.formData.corporationPersonList.length
                    this.tableData = this.formData.corporationPersonList.slice(
                        0,
                        10
                    )

                    this.$nextTick(function () {
                        setTimeout(() => {
                            this.joinAddress(this.formData.address)
                        }, 30)
                    })
                } else if (res.code == "10004") {
                    this.$message.error(res.message)
                    this.$router.push("/login")
                }
            })
        },
        handleCurrentChange(val) {
            this.query.pageNo = val
            this.tableData = this.formData.corporationPersonList.slice(
                (this.query.pageNo - 1) * this.query.pageSize,
                this.query.pageNo * this.query.pageSize
            )
        },
        handleSizeChange(val) {
            this.query.pageSize = val
            this.tableData = this.formData.corporationPersonList.slice(
                (this.query.pageNo - 1) * this.query.pageSize,
                this.query.pageNo * this.query.pageSize
            )
        },
        examineDialogClose() {
            this.$emit("setTeam")
            this.examineDialog = false
        },
        loadMap() {
            //地图加载
            return new Promise((resolve, reject) => {
                this.map = new AMap.Map("container1", {
                    resizeEnable: true,

                    zoom: 8,
                })
                resolve()
            })
        },
        joinAddress(address = "") {
            let self = this
            self.$nextTick(() => {
                let geocoder = new AMap.Geocoder({ city: "" })
                self.marker = new AMap.Marker()
                geocoder.getLocation(
                    self.formData.address,
                    function (status, result) {
                        if (status === "complete" && result.geocodes.length) {
                            let lnglat = result.geocodes[0].location
                            self.formData.longitude = lnglat.lng
                            self.formData.latitude = lnglat.lat
                            self.marker.setPosition(lnglat)
                            self.map.add(self.marker)
                            self.map.setFitView(self.marker)
                        } else {
                            log.error("根据地址查询位置失败")
                        }
                    }
                )
            })
        },
    },
}
</script>

<style lang="less" scoped>
.dialog_container {
    /deep/ .el-dialog__header {
        border-bottom: 1px solid #e5e5e5;
    }
}
.team1 {
    width: 100%;
    display: flex;
}
.team1-left {
    width: 50%;
}
.team1-content {
    width: 100%;
    margin: 10px 0;
    display: flex;
    align-items: center;
}
.team1-content > div:first-child {
    width: 120px;
    text-align: right;
}
.team1-right {
    width: 50%;
    margin-top: 20px;
    display: flex;
}
.team1-right > div:nth-child(2) {
    width: 250px;
    height: 200px;
}
.team2 {
    width: 100%;
    display: flex;
    margin-bottom: 10px;
}
.team2 > div:first-child {
    width: 120px;
    text-align: right;
}
.map_container1 {
    width: 70%;
    margin-left: 120px;
    margin-bottom: 20px;
}
</style>
